var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-box"},[(_vm.hasHeader)?_c('h4',{staticClass:"header-title m-b-20"},[_vm._t("header",function(){return [_vm._v(_vm._s(_vm.titulo))]})],2):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"footer"},[_vm._t("footer")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }